/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    PositionedDeviceData,
    ResponseReason,
} from './';

/**
 * @export
 * @interface ResponsePositionedDevicesWithTotal
 */
export interface ResponsePositionedDevicesWithTotal {
    /**
     * @type {Array<PositionedDeviceData>}
     * @memberof ResponsePositionedDevicesWithTotal
     */
    data: Array<PositionedDeviceData>;
    /**
     * @type {number}
     * @memberof ResponsePositionedDevicesWithTotal
     */
    total: number;
    /**
     * @type {ResponseReason}
     * @memberof ResponsePositionedDevicesWithTotal
     */
    reason: ResponseReason;
    /**
     * @type {string}
     * @memberof ResponsePositionedDevicesWithTotal
     */
    message: string;
}
